import { getBranchIndex, getPreviousActionId, isDefaultBranchIndex } from 'automation-ui-action-features/records/recordsUtils';
import { useQuery } from 'data-fetching-client';
import { GET_FILTER_BRANCH_DESCRIPTION } from 'automation-ui-action-features/queries/filterBranchDescriptionQueries';
import uniqueIdForObject from 'automation-ui-core/utils/uniqueIdForObject';
import { BRANCH_DESCRIPTION } from 'automation-ui-canvas/constants/Gates';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { jsx as _jsx } from "react/jsx-runtime";
const BranchDescription = ({
  flow,
  edgeId
}) => {
  const isUngatedForBranchDescriptionCards = useIsUngated(BRANCH_DESCRIPTION);
  const actionId = getPreviousActionId(edgeId);
  const action = flow === null || flow === void 0 ? void 0 : flow.getActionById(actionId);
  const connection = action !== null && action !== void 0 && action.isListBranch() ? action === null || action === void 0 ? void 0 : action.getConnection() : null;
  const branches = connection === null || connection === void 0 ? void 0 : connection.getBranches();
  const currentBranch = branches === null || branches === void 0 ? void 0 : branches.get(getBranchIndex(edgeId));
  const currentBranchFilter = currentBranch === null || currentBranch === void 0 ? void 0 : currentBranch.getFilterBranch();
  const {
    data: {
      filterDescription = ''
    } = {}
  } = useQuery(GET_FILTER_BRANCH_DESCRIPTION, {
    skip: !currentBranchFilter,
    variables: {
      objectTypeId: flow.objectTypeId,
      filterBranch: currentBranchFilter,
      uniqueId: uniqueIdForObject(currentBranchFilter)
    }
  });
  if (!currentBranchFilter || isDefaultBranchIndex(getBranchIndex(edgeId)) || !filterDescription || !isUngatedForBranchDescriptionCards) {
    return null;
  }
  return /*#__PURE__*/_jsx("span", {
    children: filterDescription
  });
};
export default BranchDescription;